/** Impl dos use cases de AgendamentoRecurso. @since G.5.9 */
import type { Page } from '@/domain/model/Page';
import type { AgendamentoRecurso, AgendamentoRecursoCommand } from '@/domain/model/Agendamento';
import type {
  AgendamentoRecursoGateway, ListAgendamentoRecursosParams,
} from '@/application/port/out/AgendamentoRecursoGateway';
import type {
  ListAgendamentoRecursosUseCase, GetAgendamentoRecursoUseCase,
  CreateAgendamentoRecursoUseCase, UpdateAgendamentoRecursoUseCase,
  DeactivateAgendamentoRecursoUseCase,
} from '@/application/port/in/AgendamentoRecursoUseCase';

export class ListAgendamentoRecursos implements ListAgendamentoRecursosUseCase {
  constructor(private readonly g: AgendamentoRecursoGateway) {}
  execute(params: ListAgendamentoRecursosParams): Promise<Page<AgendamentoRecurso>> { return this.g.list(params); }
}
export class GetAgendamentoRecurso implements GetAgendamentoRecursoUseCase {
  constructor(private readonly g: AgendamentoRecursoGateway) {}
  execute(id: string): Promise<AgendamentoRecurso> { return this.g.get(id); }
}
export class CreateAgendamentoRecurso implements CreateAgendamentoRecursoUseCase {
  constructor(private readonly g: AgendamentoRecursoGateway) {}
  execute(cmd: AgendamentoRecursoCommand): Promise<AgendamentoRecurso> { return this.g.create(cmd); }
}
export class UpdateAgendamentoRecurso implements UpdateAgendamentoRecursoUseCase {
  constructor(private readonly g: AgendamentoRecursoGateway) {}
  execute(id: string, cmd: AgendamentoRecursoCommand): Promise<AgendamentoRecurso> { return this.g.update(id, cmd); }
}
export class DeactivateAgendamentoRecurso implements DeactivateAgendamentoRecursoUseCase {
  constructor(private readonly g: AgendamentoRecursoGateway) {}
  execute(id: string): Promise<void> { return this.g.deactivate(id); }
}
